import React, { FC } from 'react';
import { ReferenceFieldTypes } from './types';
import { FormControl } from 'components/atoms';
import Input from 'components/atoms/field-input';
import Select from 'components/atoms/field-select';

const ReferenceField: FC<ReferenceFieldTypes> = ({
  register,
  errors,
  isValid,
  name,
  referenceFieldConfig,
}: ReferenceFieldTypes) => {
  if (referenceFieldConfig.fieldType === 'dropdown') {
    var parsedConfigurationValue = JSON.parse(referenceFieldConfig.configurationValue);
  }
  return (
    <>
      {referenceFieldConfig.fieldType == 'text' ? (
        <FormControl errorMessage={errors}>
          <Input
            label={referenceFieldConfig.customName}
            id={name}
            name={name}
            register={register}
            fullWidth
            valid={isValid(name)}
            required={referenceFieldConfig.isMandatory}
          />
        </FormControl>
      ) : referenceFieldConfig.fieldType == 'dropdown' ? (
        <FormControl errorMessage={errors}>
          <Select
            label={`${referenceFieldConfig.customName}`}
            id={name}
            key={name}
            register={register}
            options={parsedConfigurationValue.map((value) => ({
              name: `${value.value}`,
              value: value.value,
              id: `${value.order}`,
            }))}
            fullWidth
            required={referenceFieldConfig.isMandatory}
          />
        </FormControl>
      ) : null}
    </>
  );
};

export default ReferenceField;
